import { useState } from 'react'
import moment from 'moment'
import classnames from 'classnames'

import Button from '@components/Button'
import { THINX_TIME_FORMAT } from 'shared/time-utilites'
import TermsAndConditions from './TermsAndConditions'

import styles from '../styles.module.scss'

const FooterSection = ({ total, loading, disabled, termsAcceptedDate, setTermsAcceptedDate }) => {
    const [showTermsConditions, setShowTermsConditions] = useState(false)

    const acceptTermsHandler = () => {
        setTermsAcceptedDate(moment().format(THINX_TIME_FORMAT))
        setShowTermsConditions(!showTermsConditions)
    }
    const toggleTermsConditions = () => {
        setShowTermsConditions(!showTermsConditions)
    }

    return (
        <div className={styles.termsAndConditionsSection}>
            <h3 className="font-weight-bold">
                <T>subscription.purchase.terms.conditions.headline</T>
            </h3>
            <p className={styles.termsAndConditionsLabel}>
                <span className="font-weight-bold">
                    <T>subscription.purchase.terms.conditions.description.part1</T>
                </span>
                <T>subscription.purchase.terms.conditions.description.part2</T>
            </p>
            <Button
                iconLeft="pay-fine"
                btnStyle="link"
                type="button"
                onClick={toggleTermsConditions}
                className={classnames('brand-button--link text-base', styles.termsAndConditionsBtn)}>
                <T>subscription.purchase.terms.conditions.headline</T>
            </Button>
            {showTermsConditions && (
                <TermsAndConditions
                    closeModal={toggleTermsConditions}
                    termsAcceptedDate={termsAcceptedDate}
                    onAcceptTermsHandler={acceptTermsHandler}
                />
            )}
            <div>
                <div
                    className={classnames(
                        'mb-3',
                        'd-flex',
                        'align-items-baseline',
                        'justify-content-end',
                        styles.footerTotal
                    )}>
                    <span className="mr-2">
                        <T>subscripition.purchase.pay.label.total</T>
                    </span>
                    <h2>{total}</h2>
                </div>
                <div className="d-flex justify-content-end align-items-center">
                    <Button
                        isLoading={loading}
                        className={styles.buySubscriptionBtn}
                        btnStyle="primary"
                        type="submit"
                        disabled={!termsAcceptedDate || disabled}>
                        <T>subscription.purchase.label.buy</T>
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default FooterSection
